export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"description","content":"Desperte para a sua própria natureza tornando-se quem você realmente é"},{"property":"og:title","content":"Laboratório do Ser - Psicologia Junguiana & criatividade"},{"property":"og:description","content":"Onde a psicologia profunda atende ao chamado da alma."},{"property":"og:image","content":"https://app.laboratoriodoser.com.br/images/logo-roxa.png"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:image","content":"https://app.laboratoriodoser.com.br/images/logo-roxa.png"}],"link":[{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;700&display=swap"},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Afacad&display=swap"},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap"}],"style":[{"children":"\n              #app-loader { position:fixed; inset:0; display:flex; align-items:center; justify-content:center; background:#fcf3df; z-index:99999; }\n              #app-loader .spinner { width:40px; height:40px; border:4px solid #ad8fb0; border-top-color:#692c61; border-radius:50%; animation:spin .8s linear infinite; }\n              @keyframes spin { to { transform:rotate(360deg) } }\n            "}],"script":[{"innerHTML":"document.addEventListener('DOMContentLoaded',function(){setTimeout(function(){var l=document.getElementById('app-loader');if(l)l.remove()},100)})","tagPosition":"bodyClose"}],"noscript":[],"charset":"utf-8","viewport":"width=device-width, initial-scale=1","title":"Laboratório do ser"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true